var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "InputDropdown"
  }, [_c('button', {
    staticClass: "InputDropdown-button d-flex align-items-center justify-content-between",
    class: {
      'InputDropdown-button--withIcon': _vm.icon || _vm.image
    },
    attrs: {
      "id": ("js-dropdown-input-" + (_vm.inputId)),
      "aria-expanded": _vm.isOptionsOpen,
      "aria-haspopup": "listbox",
      "type": "button"
    },
    on: {
      "click": _vm.toggleOptions
    }
  }, [_vm.icon ? _c('span', {
    staticClass: "InputDropdown-customIcon",
    class: _vm.icon
  }) : _vm._e(), _vm.image ? _c('span', {
    staticClass: "InputDropdown-imageContainer"
  }, [_c('img', {
    staticClass: "InputDropdown-image",
    attrs: {
      "src": _vm.image,
      "alt": _vm.withSlotItem ? _vm.items[_vm.value] : _vm.getItems
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "InputDropdown-label",
    class: {
      'InputDropdown-label--withIcon': _vm.icon || _vm.image
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " "), _vm.isRequired ? _c('span', {
    staticClass: "InputDropdown-required"
  }, [_vm._v("*")]) : _vm._e()]), _vm.withSlotItem ? _vm._t("currentOption", null, {
    "item": _vm.items[_vm.value]
  }) : [_vm._v(" " + _vm._s(_vm.getItems) + " ")], _c('span', {
    staticClass: "InputDropdown-iconContainer pl-3"
  }, [_c('span', {
    staticClass: "InputDropdown-icon common-chevron-bottom",
    class: _vm.isOptionsOpen ? 'InputDropdown-icon--opened' : ''
  })])], 2), _c('div', {
    staticClass: "InputDropdown-optionsContainer"
  }, [_c('input-options', {
    attrs: {
      "backgroundColorSelected": _vm.backgroundColorSelected,
      "colorSelected": _vm.colorSelected,
      "items": _vm.items,
      "isOptionsOpen": _vm.getIsOptionsOpen,
      "value": _vm.value,
      "withSlotItem": _vm.withSlotItem
    },
    on: {
      "input": _vm.optionChanged
    },
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (_, slot) {
      return {
        key: slot,
        fn: function (props) {
          return [_vm._t(slot, null, null, props)];
        }
      };
    })], null, true)
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }